import styled from 'styled-components';
import { Card as BootstrapCard } from 'react-bootstrap';

export const Header = styled(BootstrapCard.Header)`
  height: unset;

  ${({ toggle }) =>
    toggle &&
    `
    cursor: pointer
  `}
`;
